import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { InventoryHotelsService } from 'src/app/business-service/inventory/inventory-hotels.service';

@Component({
  selector: 'app-hotel-auto-complete',
  templateUrl: './hotel-auto-complete.component.html',
  styleUrls: ['./hotel-auto-complete.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => HotelAutoCompleteComponent),
      multi: true
    }
  ]
})
export class HotelAutoCompleteComponent implements OnInit, ControlValueAccessor {
  @Input() placeHolder: string = "Search for hotels";
  @Output() predictionSelected: EventEmitter<any> = new EventEmitter();
  disabled: boolean = false;
  @Input() locationvalue: any;

  hotelName: string = "";
  predictions: any;

  private onChange: (value: any) => void = () => { };
  private onTouched: () => void = () => { };

  constructor(
    private _elementRef: ElementRef,
    private _hotelService: InventoryHotelsService
  ) { }

  ngOnInit(): void {
  }

  onInput(event: any) {
    const locationvalue = this.locationvalue || null;
    const input = event;
    this._hotelService.getPrepopulatedData(locationvalue, input).subscribe(
      response => {
        // Filter out hotels with status 'Inactive'
        this.predictions = response.filter((hotel: any) => hotel.status !== 'Inactive');
      },
      error => {
        console.error("error of api", error);
      }
    )
  }

  selectPrediction(prediction: any) {
    this.hotelName = prediction?.hotelDetails?.hotelName;

    this.predictionSelected.emit(prediction);
    this.predictions = [];
    this.onChange(this.hotelName); // Notify the form about the selected value
  }

  @HostListener('document:click', ['$event'])
  handleOutsideClick(event: MouseEvent) {
    const targetElement = event.target as HTMLElement;
    if (!this._elementRef.nativeElement.contains(targetElement)) {
      this.predictions = [];
    }
  }
  // ControlValueAccessor methods
  writeValue(value: any): void {
    if (value !== undefined) {
      this.hotelName = value; // Handle both selected value or free-text
    }
  }

  // register the changes 
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  // register when touched
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  // handle disable state
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
    // Method to handle free text input changes
    onFreeTextInput(event: any) {
      this.onChange(this.hotelName); // Notify the form about free text value
    }
}
